import { ErrorMessagesViewModelKey, IErrorMessageComponentProps } from '../../../../models/AppState';
import { AdminReportingViewModel } from '../../../../viewmodels/AdminViewModels';
import { LoadingSpinner } from '../../../../web/components/LoadingSpinner';
import { styleSheet } from './styles';
import { StyleDeclarationValue, css } from 'aphrodite';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { withRouter } from 'react-router';
import { RouteComponentProps } from 'react-router-dom';

interface IProps extends IErrorMessageComponentProps, RouteComponentProps<any> {
	className?: string;
	reportsVM: AdminReportingViewModel;
	styles?: StyleDeclarationValue[];
}

class _DailyActiveUseSection extends React.Component<IProps> {
	public render() {
		const { className, styles, reportsVM } = this.props;

		return (
			<div className={`${css(styleSheet.container, ...(styles || []))} daily-active-use-section ${className || ''}`}>
				<div className={css(styleSheet.leftSection)}>
					{!!reportsVM.isLoadingActiveUseSummary && <LoadingSpinner type='login' />}
					{!reportsVM.isLoadingActiveUseSummary && (
						<div className={css(styleSheet.topRow)}>
							<div className={css(styleSheet.valueColumn)}>
								<div className={css(styleSheet.title, styleSheet.colorLightBlue)}>Daily Active Use</div>
								<div className={css(styleSheet.percentLarge)}>{reportsVM.validDailyActiveUse}</div>
							</div>
							<div className={css(styleSheet.valueColumn)}>
								<div className={css(styleSheet.title, styleSheet.colorGreen)}>Green</div>
								<div className={css(styleSheet.percent)}>{reportsVM.validGreenActiveUse}</div>
							</div>
							<div className={css(styleSheet.valueColumn)}>
								<div className={css(styleSheet.title, styleSheet.colorYellow)}>Yellow</div>
								<div className={css(styleSheet.percent)}>{reportsVM.validYellowActiveUse}</div>
							</div>
							<div className={css(styleSheet.valueColumn)}>
								<div className={css(styleSheet.title, styleSheet.colorOrange)}>Orange</div>
								<div className={css(styleSheet.percent)}>{reportsVM.validOrangeActiveUse}</div>
							</div>
							<div className={css(styleSheet.valueColumn)}>
								<div className={css(styleSheet.title, styleSheet.colorRed)}>New Red</div>
								<div className={css(styleSheet.percent)}>{reportsVM.validNewRedActiveUse}</div>
							</div>
						</div>
					)}
					<div className={css(styleSheet.bottomRow)}>
						<div>
							<div className={css(styleSheet.industry, styleSheet.colorLightBlue)}>
								Insurance:
								<span className={css(styleSheet.percentSmall)}>{reportsVM.validInsuranceActiveUse}</span>
							</div>
							<div className={css(styleSheet.industry, styleSheet.colorLightBlue)}>
								Real Estate:
								<span className={css(styleSheet.percentSmall)}>{reportsVM.validRealEstateActiveUse}</span>
							</div>
							<div className={css(styleSheet.industry, styleSheet.colorLightBlue)}>
								Financial:
								<span className={css(styleSheet.percentSmall)}>{reportsVM.validFinancialActiveUse}</span>
							</div>
							<div className={css(styleSheet.industry, styleSheet.colorLightBlue)}>
								Mortgage:
								<span className={css(styleSheet.percentSmall)}>{reportsVM.validMortgageActiveUse}</span>
							</div>
							<div className={css(styleSheet.industry, styleSheet.colorLightBlue)}>
								Legal:
								<span className={css(styleSheet.percentSmall)}>{reportsVM.validLegalActiveUse}</span>
							</div>
						</div>
						<button className={css(styleSheet.breakItDown)} onClick={this.navigateToDailySummary}>
							<span className={css(styleSheet.breakItDownText)}>{'Break it down >>>'}</span>
						</button>
					</div>
				</div>
				<div className={css(styleSheet.rightSection)}>
					<svg width='305' height='262' fill='none' xmlns='http://www.w3.org/2000/svg'>
						<path d='M74 83s-31.404 11.389-37.427 21.902C30.55 115.415 74 83 74 83z' fill='#C75DA6' />
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M17.466 119.53c.322.331.767.5 1.22.466 2.25 0 8.748-2.592 30.64-17.852 14.08-9.815 27.835-20.233 27.972-20.337L81 79l-4.324 1.593c-2.008.74-49.288 18.318-58.692 34.998-.7 1.245-1.518 3.007-.518 3.939zm1.677-3.24c7.459-13.232 40.916-27.606 53.331-32.579-5.15 3.84-14.542 10.765-24.062 17.396-27.307 19.024-29.848 17.616-30.05 17.391-.002-.003-.212-.446.782-2.208z'
							fill='#3F3D56'
						/>
						<path d='M76 73.083s-30.563-3.725-39.835 2.64C26.894 82.09 76 73.084 76 73.084z' fill='#C75DA6' />
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M24.14 75.652c.328.737 1.046 2.348 11.477 2.348 4.128 0 9.778-.252 17.526-.911 13.286-1.13 26.451-2.934 26.583-2.953l3.274-.45-3.196-.821c-1.666-.428-40.959-10.375-53.895-.533-.6.457-2.424 1.845-1.769 3.32zm2.605-2.3c3.944-3 10.666-4.026 18.014-4.026 11.742 0 25.081 2.62 31.243 3.986-4.809.613-13.864 1.706-22.977 2.481-24.455 2.08-27.342.025-27.644-.654-.12-.27.174-.881 1.364-1.786z'
							fill='#3F3D56'
						/>
						<path d='M83 68S67.916 30.89 71.571 27.216C75.226 23.542 83 68 83 68z' fill='#C75DA6' />
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M82.171 66.11L84 71l-.554-5.218c-.54-5.09-5.447-49.803-11.184-52.6a1.659 1.659 0 00-1.758.155c-1.023.714-4.137 2.886 3.46 28.314 3.67 12.289 8.12 24.227 8.206 24.457l.001.003zM71.238 14.49a.477.477 0 01.273-.104c.067.002.132.02.191.052 3.457 1.685 7.571 27.134 9.806 45.972-6.515-18.27-13.925-43.37-10.27-45.92z'
							fill='#3F3D56'
						/>
						<path d='M89 76s7.95-36 16.279-36S89 76 89 76z' fill='#C75DA6' />
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M87.792 74.941L87 78l1.96-2.444c3.667-4.577 35.719-44.964 31.691-53.722-.386-.837-1.279-1.834-3.35-1.834-15.108 0-28.928 52.698-29.51 54.941zm2.176-2.843c3.287-11.596 15.274-50.72 27.333-50.72 1.653 0 2.016.784 2.135 1.044h.001c2.904 6.315-18.653 35.882-29.469 49.676z'
							fill='#3F3D56'
						/>
						<path d='M94 77s27.728-15.943 84.537-11.076C235.345 70.79 94 77 94 77z' fill='#C75DA6' />
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M92.463 75.76L91 77l1.926-.055c.248-.006 25.021-.716 49.538-2.241 50.17-3.121 50.423-6.488 50.531-7.926.109-1.455-1.521-3.107-14.078-5.324-29.721-5.249-51.62-1.097-64.757 3.311-14.276 4.789-21.4 10.744-21.697 10.995zm2.576-.228c5.534-3.84 24.621-15.182 56.904-15.182 8.967.029 17.913.842 26.734 2.43 12.929 2.284 12.963 3.834 12.958 3.898-.045.607-2.634 3.78-49.254 6.68-20.306 1.263-40.79 1.967-47.342 2.174z'
							fill='#3F3D56'
						/>
						<path d='M112 78.026s49.138-.64 51.899 4.473C166.659 87.61 112 78.026 112 78.026z' fill='#C75DA6' />
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M111.076 78.496C116.049 80.098 153.52 92 169.108 92c3.019 0 5.218-.447 6.201-1.5.47-.505.944-1.397.535-2.79-3.452-11.748-58.339-10.777-64.587-10.629l-4.257.102 4.076 1.313zm63.267 10.985c-3.899 4.184-35.708-3.881-58.616-11.02 18.932-.137 56.367 1.334 58.82 9.681.222.756.008 1.113-.204 1.34z'
							fill='#3F3D56'
						/>
						<path d='M103 84s28.919 13.366 23.268 17.479C120.617 105.592 103 84 103 84z' fill='#C75DA6' />
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M99.905 81.261c1.346 1.598 30.281 35.737 44.493 35.737a6.474 6.474 0 003.824-1.123c1.286-.906 1.894-2.117 1.76-3.501-1.013-10.44-47.311-31.283-49.282-32.165L98 79l1.905 2.261zm47.536 33.509c-8.471 5.974-33.332-19.253-44.505-32.056 14.714 6.806 44.969 22.284 45.698 29.79.088.91-.291 1.63-1.193 2.266z'
							fill='#3F3D56'
						/>
						<path
							d='M153 99s23.457 10.076 18.244 16.793C166.032 122.51 153 99 153 99zm-48-8s50.394 55.484 45.69 58.867C145.987 153.25 105 91 105 91zm-8-3s20.646 34.456 16.433 37.806C109.219 129.156 97 88 97 88z'
							fill='#C75DA6'
						/>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M119.564 139.868c.267.086.547.13.83.132.47.001.929-.138 1.312-.397 2.155-1.427 3.351-6.034-11.077-29.464-7.731-12.554-16.433-24.693-16.682-25.04l-.005-.007L91 81l1.671 4.69c1.879 5.274 18.598 51.599 26.893 54.178zm.447-1.288c-5.784-1.798-18.061-31.944-24.16-48.328 3.262 4.696 8.603 12.552 13.543 20.575 13.925 22.615 12.675 26.881 11.491 27.665a.95.95 0 01-.874.088zm-24.16-48.328z'
							fill='#3F3D56'
						/>
						<path d='M87.212 86s-19.148 58.599-7.398 57.995C91.564 143.391 87.212 86 87.212 86z' fill='#C75DA6' />
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M70.566 150.598c1.072 1.595 2.663 2.402 4.733 2.402.1 0 .202-.002.304-.006 2.353-.087 4.432-1.151 6.18-3.161 11.056-12.722 6.175-60.343 5.962-62.364L87.485 85l-1.028 2.261c-.963 2.12-23.499 52.022-15.891 63.337zm1.123-.752c-6.292-9.357 10.494-49.426 14.949-59.65.869 10.276 3.365 48.118-5.876 58.753-1.514 1.741-3.217 2.623-5.209 2.697-1.743.067-3.007-.524-3.864-1.8z'
							fill='#3F3D56'
						/>
						<path d='M80 89s-31.715 36.877-28.812 40.761C54.09 133.644 80 89 80 89z' fill='#C75DA6' />
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M39.79 144.6a1.91 1.91 0 001.2.4c.165-.001.329-.018.49-.05 8.876-1.74 41.838-58.821 43.237-61.25L88 78l-4.386 4.892c-1.855 2.07-45.425 50.79-44.603 60.14.023.611.307 1.182.78 1.568zm.588-1.689c-.57-6.491 25.192-37.384 39.627-53.866-11.225 18.991-32.653 53.349-38.788 54.551a.667.667 0 01-.584-.085.756.756 0 01-.255-.6z'
							fill='#3F3D56'
						/>
						<path d='M70 66S41.555 30.824 15.252 34.233C-11.051 37.642 70 66 70 66z' fill='#C75DA6' />
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M70.813 65.49L73 66l-1.558-1.649A146.064 146.064 0 0049.7 46.183c-11.624-7.858-28.65-16.32-43.728-12.024-4.063 1.158-6.016 2.672-5.97 4.63.037 1.623.152 6.562 35.709 17.303 17.364 5.245 34.927 9.357 35.103 9.398zM6.33 35.473a30.072 30.072 0 018.27-1.116c22.71 0 47.616 22.805 54.208 29.26-27.887-6.635-67.32-18.312-67.472-24.86-.027-1.192 1.746-2.359 4.994-3.284z'
							fill='#3F3D56'
						/>
						<path
							d='M47 61.549S9.408 58.77 12.142 65.716C14.876 72.662 47 61.55 47 61.55zM58 36s-1.968-9.806-5.249-7.705C49.471 30.396 58 36 58 36zm36 7s9.027-37.86 4.936-38C94.844 4.861 94 43 94 43z'
							fill='#C75DA6'
						/>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M93.024 46.806L93.095 52l1.177-5.039c.982-4.201 9.484-41.188 5.814-46.217A1.654 1.654 0 0098.728 0a1.95 1.95 0 00-1.442.713c-4.769 5.179-4.285 44.425-4.262 46.094zm5.165-45.14c.284-.31.476-.31.54-.31a.423.423 0 01.358.223c2.228 3.053-1.33 23.696-4.82 39.64.042-13.38.773-36.134 3.922-39.554z'
							fill='#3F3D56'
						/>
						<path
							d='M136 49s4.083-10.276 8.167-7.535C148.25 44.205 136 49 136 49zm-39.517 90s-5.568 38.647 4.873 37.992c10.441-.655-4.873-37.992-4.873-37.992z'
							fill='#C75DA6'
						/>
						<path
							d='M125.736 129.572s-5.443-8.571-5.443-14.571c0 0-9.525-9.428-6.804-12 2.721-2.571 8.618 7.286 8.618 7.286s-10.886-11.571-7.711-13.285c3.175-1.715 13.607 11.142 13.607 11.142l3.629-1.714s-7.707-17.96-2.268-18.428c2.495-.214 8.165 17.142 8.165 17.142l5.896 14.142s2.268 5.143 1.361 8.143a53.841 53.841 0 00-1.361 5.571l-17.689-3.428z'
							fill='#FFB9B9'
						/>
						<path
							opacity='.1'
							d='M138.775 132s3.103-4.889 1.98-12.354c-1.123-7.465-7.299-11.646-7.299-11.646s-3.99 3.111 0 11.111c0 0-4.876 4.445-.887 11.556'
							fill='#000'
						/>
						<path
							d='M139.775 132s3.103-4.889 1.98-12.354c-1.123-7.465-7.299-11.646-7.299-11.646s-3.99 3.111 0 11.111c0 0-4.876 4.445-.887 11.556'
							fill='#FFB9B9'
						/>
						<path
							opacity='.1'
							d='M127 108.198l-2.296-3.802s-10.856-1.789-9.603 2.237c1.252 4.025 6.262 2.236 6.262 2.236l2.923 3.131 2.714-3.802z'
							fill='#000'
						/>
						<path
							d='M130 108.316l-3.073-4.92s-9.987-1.789-8.834 2.237c1.152 4.025 5.761 2.236 5.761 2.236l2.689 3.131 3.457-2.684zm81.18 56.934L209 181.917 243 184v-20l-31.82 1.25z'
							fill='#FFB9B9'
						/>
						<path
							d='M305 262l-27.626-54.484c-1.65-5.39-6.804-14.167-22.817-19.806l-12.01-10.019-8.953-.317-35.812-5.168s-27.514-1.723-45.42 9.044l-4.804-2.154s-7.861-27.563-4.367-47.373L123.101 130s-10.918 46.943-5.678 61.155c5.241 14.212 24.457 24.548 24.457 24.548l17.033 16.796 6.551 29.286h102.195l1.627-7.684 7.981 7.684L305 262z'
							fill='#fff'
						/>
						<path
							d='M266.679 163.257c-32.111 8.659-63.671 9.271-94.565.133-3.631-1.074-6.114-4.258-6.114-7.872V65.4c0-4.033 3.073-7.472 7.26-8.128 29.143-4.564 60.016-4.21 92.306.17 4.267.58 7.434 4.058 7.434 8.154v89.732c0 3.689-2.586 6.921-6.321 7.929z'
							fill='#fff'
						/>
						<path
							d='M200.86 102.284s-7.406-10.822-2.849-13.67c4.558-2.847 11.395 5.127 11.395 5.127s8.546-7.405 13.103-4.557c4.558 2.848-4.557 13.1-4.557 13.1s6.836 1.709 7.406 6.266c.57 4.557 2.849 16.518-6.837 17.087-5.188.305-8.088-1.188-9.662-2.64a3.176 3.176 0 00-4.182-.049c-3.284 2.766-9.199 5.955-13.502-1.867-1.709-11.962 9.685-18.797 9.685-18.797zm53.28 1s7.406-10.822 2.849-13.67c-4.558-2.847-11.395 5.127-11.395 5.127s-8.546-7.405-13.103-4.557c-4.558 2.848 4.557 13.1 4.557 13.1s-6.836 1.709-7.406 6.266c-.57 4.557-2.849 16.518 6.837 17.087 5.188.305 8.088-1.188 9.662-2.64a3.176 3.176 0 014.182-.049c3.284 2.766 9.199 5.955 13.502-1.867 1.709-11.962-9.685-18.797-9.685-18.797zm-63.551 29.809s10.619 8.474 33.263 7.939c22.644-.534 29.967-1.45 34.807-6.74 4.84-5.289 6.275.82 4.772 4.825-1.503 4.004-3.433 10.838-14.714 11.946-7.426.729-23.478.902-33.579.935a52.005 52.005 0 01-22.978-5.14c-4.383-2.145-7.158-6.57-7.16-11.415.001-1.888.336-2.907 1.576-3.279 2.234-.67 4.013.929 4.013.929z'
							fill='#3F3D56'
						/>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M172.075 164.218a171.878 171.878 0 0052.303 7.779c17.231-.108 35.166-2.777 53.307-7.933a10.1 10.1 0 007.315-9.673V48.971a10.086 10.086 0 00-8.603-9.947c-37.048-5.298-71.7-5.365-102.995-.199A10.01 10.01 0 00165 48.74v105.875a10.02 10.02 0 007.075 9.603zm1.447-124.66a298.306 298.306 0 0148.564-3.816 383.478 383.478 0 0154.206 4.017 9.34 9.34 0 017.967 9.211v105.421a9.354 9.354 0 01-6.776 8.959c-36.689 10.429-72.078 10.482-105.188.159a9.279 9.279 0 01-6.554-8.894V48.74a9.27 9.27 0 017.781-9.183z'
							fill='#3F3D56'
						/>
						<path
							d='M220.531 52c-8.144 0-15.112-.348-20.818-.819-17.947-1.481-27.617-4.47-27.713-4.5l.232-.669c.095.03 9.707 2.999 27.579 4.471 16.495 1.36 43.602 1.685 79.056-4.483l.133.692C255.707 50.744 236.003 52 220.531 52z'
							fill='#3F3D56'
						/>
					</svg>
				</div>
			</div>
		);
	}

	private navigateToDailySummary = () => {
		const { history } = this.props;
		history.push('/reports/daily');
	};
}

const DailyActiveUseSectionAsObserver = observer(_DailyActiveUseSection);
const DailyActiveUseSectionInjected = inject(ErrorMessagesViewModelKey)(DailyActiveUseSectionAsObserver);
export const DailyActiveUseSection = withRouter(DailyActiveUseSectionInjected);
